/*
 * Nav de abas da Tela 6 (Regras e Canais) — FE-6a.
 *
 * CONTROLADA (espelha a ideia do `CadastrosLayout`, mas sem rota por aba: a aba
 * ativa é estado da página `RegrasCanais`, não um `<NavLink>`). Recebe `abaAtiva` +
 * `aoTrocar`; a aba ativa fica `text-flame`, a inativa `text-off-black
 * hover:text-flame`. SÓ classes Tailwind dos tokens CPMH.
 */

export type AbaRegrasCanais = "regras" | "canais";

interface AbaDef {
  valor: AbaRegrasCanais;
  rotulo: string;
}

const ABAS: readonly AbaDef[] = [
  { valor: "regras", rotulo: "Regras" },
  { valor: "canais", rotulo: "Canais" },
];

interface AbasRegrasCanaisProps {
  abaAtiva: AbaRegrasCanais;
  aoTrocar: (aba: AbaRegrasCanais) => void;
}

export function AbasRegrasCanais({
  abaAtiva,
  aoTrocar,
}: AbasRegrasCanaisProps): JSX.Element {
  return (
    <nav
      aria-label="Seções de regras e canais"
      className="flex flex-wrap gap-2 border-b border-platinum"
    >
      {ABAS.map((aba) => {
        const ativa = aba.valor === abaAtiva;
        return (
          <button
            key={aba.valor}
            type="button"
            aria-pressed={ativa}
            onClick={() => aoTrocar(aba.valor)}
            className={
              ativa
                ? "font-subtitulo text-base text-flame"
                : "font-subtitulo text-base text-off-black hover:text-flame"
            }
          >
            {aba.rotulo}
          </button>
        );
      })}
    </nav>
  );
}
